import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import useMarketStateStore from 'store/useMarketStateStore';
import { DEFAULT_ADMIN_PROFILE_ID, isMarketStateSet } from 'utils/isMarketStateSet';
import { GroupOption, MarketMetric } from 'generated/graphql';
import useDefaultShippingMethod from './useDefaultShippingMethod';
import useProfileConfig from './useProfileConfig';
import useSearch from './useSearch';
import useUser from './useUser';

const useInitializeMarketStateStore = () => {
  const marketStateStore = useMarketStateStore();
  const { isSeller, user, isAdmin } = useUser();
  const [getParam] = useSearch();
  const defaultShippingMethod = useDefaultShippingMethod();
  const { profileID } = useProfileConfig();
  const { pathname } = useLocation();

  const { input, setInput } = marketStateStore;
  const isStateSet = isMarketStateSet(input);
  const searchDefined = input?.search !== undefined;
  const isCatalogRoute = pathname.includes('/catalog-market');

  useEffect(() => {
    if (!isStateSet && !isSeller && user) {
      const currBuyerID = !isAdmin && user?.profileId ? `${user.profileId}` : DEFAULT_ADMIN_PROFILE_ID;

      const queryTruckType = getParam('truckTypeUUID');
      setInput({
        search: '',
        filters: [],
        truckTypeUUID: queryTruckType ?? DEFAULT_ADMIN_PROFILE_ID,
        buyerID: currBuyerID,
        method: defaultShippingMethod,
        groupOption: GroupOption.Seller,
        metric: isCatalogRoute ? MarketMetric.Units : MarketMetric.Pallets,
      });
    }

    if (!searchDefined) {
      setInput({
        search: '',
      });
    }
  }, [
    isStateSet,
    searchDefined,
    setInput,
    defaultShippingMethod,
    getParam,
    isAdmin,
    isSeller,
    user,
    profileID,
    isCatalogRoute,
  ]);

  const prevCatalogRef = useRef(isCatalogRoute);
  useEffect(() => {
    if (prevCatalogRef.current === isCatalogRoute) return;
    prevCatalogRef.current = isCatalogRoute;
    setInput({ metric: isCatalogRoute ? MarketMetric.Units : MarketMetric.Pallets });
  }, [isCatalogRoute, setInput]);

  return marketStateStore;
};

export default useInitializeMarketStateStore;
